import { Box, Flex, Image } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import CustomHeading from "../../../components/text/CustomHeading";
import CustomText from "../../../components/text/CustomText";
import IconChevDown from "../../../svgs/IconChevDown";
import UploadIcon from "../../../svgs/UploadIcon";
import CustomButton from "../../../components/buttons/CustomButton";
import { IconCheck } from "@tabler/icons-react";
import PassportIcon from "../../../assets/images/passport.png";
import IDCard from "../../../assets/images/id-card.png";
import Selfie from "../../../assets/images/selfie.jpg";
import DrivingLicense from "../../../assets/images/driving-license.jpg";

function Documents({ payload, setPayload }: any) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loadingFor, setLoadingFor] = useState("");

  const img1Ref = useRef<any>(null);
  const img2Ref = useRef<any>(null);
  const img3Ref = useRef<any>(null);
  const img4Ref = useRef<any>(null);

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handlePassportChange = (e: any) => {
    setLoadingFor("passport");
    const file = e.target.files[0];
    convertToBase64(file).then((base64: any) => {
      setPayload({
        ...payload,
        documentUrls: [base64],
      });
      img1Ref.current.value = "";
      setLoadingFor("");
    });
  };

  const handleProfileChange = (e: any) => {
    setLoadingFor("profile");
    const file = e.target.files[0];
    convertToBase64(file).then((base64: any) => {
      setPayload({
        ...payload,
        profileImg: base64,
      });
      img4Ref.current.value = "";
      setLoadingFor("");
    });
  };

  const handleIqamaFrontChange = (e: any) => {
    setLoadingFor("iqamaFront");
    const file = e.target.files[0];

    convertToBase64(file).then((base64: any) => {
      setPayload({
        ...payload,
        documentUrls: [...payload?.documentUrls, base64],
      });
      setLoadingFor("");
    });
  };

  const handleIqamaBackChange = (e: any) => {
    setLoadingFor("iqamaBack");
    const file = e.target.files[0];
    convertToBase64(file).then((base64: any) => {
      setPayload({
        ...payload,
        documentUrls: [...payload?.documentUrls, base64],
      });
      setLoadingFor("");
    });
  };

  return (
    <Flex flexDir="column" gap="24px" maxW="666px" w="100%" mx="auto">
      <CustomHeading text="KYC" family="aeonik-bold" align="center" />
      <CustomText
        text="Enter documents details"
        align="center"
        color="yess.neutral600"
      />
      <Flex flexDir="column" gap="10px">
        <CustomText
          text="KYC Verification Instructions"
          color="yess.base_black"
        />
        <Flex gap="4px" align="center">
          <CustomText text="1." color="yess.base_black" />
          <CustomText
            text="Either Upload a government-issued photo ID (e.g., passport, driver’s license, or national ID card)."
            color="yess.base_neutral700"
            size="14px"
          />
        </Flex>
        <Flex gap="4px" align="center">
          <CustomText text="2." color="yess.base_black" />
          <CustomText
            text="Take a clear selfie holding your ID next to your face. Ensure the ID details are legible."
            color="yess.base_neutral700"
            size="14px"
          />
        </Flex>
      </Flex>
      <Flex flexDir="column" gap="10px">
        <CustomText text="Approved KYC Examples" color="yess.base_black" />
        <Flex align="center" wrap="wrap" justify="center">
          <Image
            src={PassportIcon}
            alt="passport"
            boxSize="250px"
            objectFit="contain"
            me="24px"
          />
          <Image
            src={IDCard}
            alt="id-card"
            boxSize="250px"
            objectFit="contain"
          />
          <Image
            src={Selfie}
            alt="selfie"
            boxSize="170px"
            objectFit="contain"
            me="24px"
            mt="-70px"
          />
          <Image
            src={DrivingLicense}
            alt="driving-license"
            boxSize="250px"
            mt="-70px"
            objectFit="contain"
          />
        </Flex>
      </Flex>
      <Box pos="relative">
        <Flex
          flexDir="column"
          gap="11px"
          w="100%"
          cursor="pointer"
          onClick={() => {
            setIsMenuOpen(!isMenuOpen);
          }}
        >
          <CustomText text="Document Type" size="12px" />
          <Flex
            px="24px"
            h="38px"
            align="center"
            justify="space-between"
            bg="#f2f2f2"
            borderRadius="8px"
          >
            <CustomText
              text={payload?.documentType}
              size="14px"
              color="yess.neutral_black"
            />
            <IconChevDown />
          </Flex>
        </Flex>
        <Flex
          flexDir="column"
          gap="12px"
          p="12px 24px"
          bg="#f2f2f2"
          borderRadius="12px"
          pos="absolute"
          mt="5px"
          w="100%"
          zIndex="1000"
          display={isMenuOpen ? "flex" : "none"}
          boxShadow={`0px 4px 4px rgba(0, 0, 0, 0.25)`}
        >
          {["Passport", "Driving License", "ID Card"]?.map((type, idx) => (
            <Flex
              key={idx}
              align="center"
              cursor="pointer"
              justify="space-between"
              onClick={() => {
                setIsMenuOpen(false);
                setPayload({
                  ...payload,
                  documentType: type,
                  documentUrls: [],
                });
              }}
            >
              <CustomText
                text={type}
                size="12px"
                color="yess.nuetral900"
                cursor="pointer"
              />
              {payload?.documentType === type && (
                <IconCheck size="12px" color="#000000" />
              )}
            </Flex>
          ))}
        </Flex>
      </Box>
      {payload?.documentType !== "Iqama" ? (
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText
            text={`Upload ${payload?.documentType} Picture`}
            size="12px"
          />
          <Flex
            p="32px"
            w="100%"
            align="center"
            justify="center"
            flexDir="column"
            gap="16px"
            bg="#F2F2F2"
            borderRadius="16px"
            border="1px dashed #908B8B"
          >
            {payload?.documentUrls?.length > 0 ? (
              <>
                <Image
                  src={payload?.documentUrls[0]}
                  alt="passport"
                  objectFit="cover"
                />
                <CustomButton
                  btnTitle="Browse"
                  maxW="111px"
                  height="36px"
                  radius="8px"
                  bg="yess.secondary_gold"
                  size="14px"
                  weight="400"
                  isLoading={loadingFor === "passport"}
                  onClick={() => img1Ref.current.click()}
                />
              </>
            ) : (
              <>
                <UploadIcon />
                <CustomText text="Browse Files" color="yess.base_black" />
                <CustomButton
                  btnTitle="Browse"
                  maxW="111px"
                  height="36px"
                  radius="8px"
                  bg="yess.secondary_gold"
                  size="14px"
                  weight="400"
                  isLoading={loadingFor === "passport"}
                  onClick={() => img1Ref.current.click()}
                />
              </>
            )}
          </Flex>
        </Flex>
      ) : (
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Upload Picture" size="12px" />
          <Flex gap="12px">
            <Flex
              p="32px"
              w="100%"
              align="center"
              justify="center"
              flexDir="column"
              gap="16px"
              bg="#F2F2F2"
              borderRadius="16px"
              border="1px dashed #908B8B"
            >
              {payload?.documentUrls?.length > 0 ? (
                <Image
                  src={payload?.documentUrls[0]}
                  alt="passport"
                  objectFit="cover"
                />
              ) : (
                <>
                  <UploadIcon />
                  <CustomText text="Front Side" color="yess.base_black" />
                  <CustomButton
                    btnTitle="Browse"
                    maxW="111px"
                    height="36px"
                    radius="8px"
                    bg="yess.secondary_gold"
                    size="14px"
                    weight="400"
                    isLoading={loadingFor === "iqamaFront"}
                    onClick={() => img2Ref.current.click()}
                  />
                </>
              )}
            </Flex>
            <Flex
              p="32px"
              w="100%"
              align="center"
              justify="center"
              flexDir="column"
              gap="16px"
              bg="#F2F2F2"
              borderRadius="16px"
              border="1px dashed #908B8B"
            >
              {payload?.documentUrls?.length > 1 ? (
                <Image
                  src={payload?.documentUrls[1]}
                  alt="passport"
                  objectFit="cover"
                />
              ) : (
                <>
                  <UploadIcon />
                  <CustomText text="Back Side" color="yess.base_black" />
                  <CustomButton
                    btnTitle="Browse"
                    maxW="111px"
                    height="36px"
                    radius="8px"
                    bg="yess.secondary_gold"
                    size="14px"
                    weight="400"
                    isLoading={loadingFor === "iqamaBack"}
                    onClick={() => img3Ref.current.click()}
                  />
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      )}
      <Flex flexDir="column" gap="11px" w="100%">
        <CustomText text="Upload Profile Picture" size="12px" />
        <Flex
          p="32px"
          w="100%"
          align="center"
          justify="center"
          flexDir="column"
          gap="16px"
          bg="#F2F2F2"
          borderRadius="16px"
          border="1px dashed #908B8B"
        >
          {payload?.profileImg ? (
            <>
              <Image
                src={payload?.profileImg}
                alt="passport"
                objectFit="cover"
              />
              <CustomButton
                btnTitle="Browse"
                maxW="111px"
                height="36px"
                radius="8px"
                bg="yess.secondary_gold"
                size="14px"
                weight="400"
                isLoading={loadingFor === "profile"}
                onClick={() => img4Ref.current.click()}
              />
            </>
          ) : (
            <>
              <UploadIcon />
              <CustomText text="Browse Files" color="yess.base_black" />
              <CustomButton
                btnTitle="Browse"
                maxW="111px"
                height="36px"
                radius="8px"
                bg="yess.secondary_gold"
                size="14px"
                weight="400"
                isLoading={loadingFor === "profile"}
                onClick={() => img4Ref.current.click()}
              />
            </>
          )}
        </Flex>
      </Flex>
      <input type="file" hidden ref={img1Ref} onChange={handlePassportChange} />
      <input
        type="file"
        hidden
        ref={img2Ref}
        onChange={handleIqamaFrontChange}
      />
      <input
        type="file"
        hidden
        ref={img3Ref}
        onChange={handleIqamaBackChange}
      />
      <input type="file" hidden ref={img4Ref} onChange={handleProfileChange} />
    </Flex>
  );
}

export default Documents;
